var _path, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLengthIconSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 33.2383V17.2383H11V24.8242L16.0608 19.7634L17.475 21.1776L14.4143 24.2383H35.657L32.5963 21.1776L34.0105 19.7634L39 24.7529V17.2383H40V33.2383H39V25.7237L34.0105 30.7132L32.5963 29.2989L35.657 26.2383H14.4143L17.475 29.2989L16.0608 30.7132L11 25.6524V33.2383H10Z",
    fill: "#522D56"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 44.2383,
    x2: 44,
    y2: 44.2383,
    stroke: "#522D56",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLengthIconSelected);
export default __webpack_public_path__ + "static/media/Length_icon_selected.2ff67d0cff0c9af9460751f03565d61e.svg";
export { ForwardRef as ReactComponent };